<template>
  <v-container class="pt-1">
    <v-subheader class="pl-0">
      {{ headerTitle }}
      <v-btn icon>
        <v-icon @click.native="showGroupDialog = true">mdi-plus-circle</v-icon>
      </v-btn>

    </v-subheader>

    <div>

      <v-container class="pa-0">
        <v-list>
          <v-list-item-group>
            <v-list-item style="background-color: #F5F5F5;border-radius: 8px;" @click="selectAllGroups">

              <v-btn text style="all: unset; font-size: 14px;">
                <strong> 전체 </strong>
              </v-btn>




            </v-list-item>
          </v-list-item-group>

          <v-divider class="mt-2"></v-divider>
        </v-list>
      </v-container>

      

      <div class="flex justify-between">

        <draggable v-model="list" class="dragArea" @change="handleDrag" style="border: 1px solid #fff;">
          <transition-group tag="div" class="drag-list">
            <v-list-item v-for="element in list" :key="elementKey(element)"
              style="background-color: #F5F5F5;border-radius: 8px; margin-bottom: 5px;cursor: pointer;" class="pl-3 pr-1"
              @click.prevent="selectGroup(element)">

              <v-row>
                <div>
                  <v-btn text style="all: unset; font-size: 13px; ">
                    <strong>
                      {{ element.group_name }}
                    </strong>
                  </v-btn>
                </div>
              </v-row>

              <div class="text-right">

                <v-menu
                  right
                  offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="optionmenu(element)"
                      >
                      <v-icon small class="mdi mdi-dots-vertical"/>
                      </v-btn>
                    </template>

                    <v-list class="pa-0">
                      <v-list-item @click.stop="openModifyGroupName(element)" class="optionlist">
                        <v-icon style="font-size: 20px;">mdi-pencil</v-icon>
                      </v-list-item>
                      <v-list-item @click.stop="remove(element.id)" class="optionlist">
                        <v-icon style="font-size: 20px;">mdi-trash-can-outline</v-icon>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                <!-- <v-btn x-small icon @click.stop="openModifyGroupName(element)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn x-small icon @click.stop="remove(element.id)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn> -->
              </div>
            </v-list-item>
          </transition-group>
        </draggable>


      </div>

      <AppDialog :value="showGroupDialog" :persistent="true" @input="showGroupDialog = $event">
        <template v-slot:title>
          <span>그룹 추가</span>
        </template>
        <!-- <template v-slot:close>
          <v-icon @click="showGroupDialog = false">mdi-close</v-icon>
        </template> -->
        <template v-slot:content>
          <div class="suport_box">
            원하는 그룹명을 생성하여 추가해보세요. (<strong>최대 10자</strong>)
          </div>
          <AppTextField v-model="groupName" />

          <Alert :message="message" :message-type="messageType"></Alert>

        </template>
        <template v-slot:actions>
          <TextButtonBlock buttonText="취소" @click="showGroupDialog = false" />
          <TextButtonBlock buttonText="추가" @click="handleAdd()" isPrimary />
        </template>
      </AppDialog>

      <AppDialog :value="showGroupEditDialog" :persistent="true" @input="showGroupEditDialog = $event">
        <template v-slot:title>
          <span>그룹 수정</span>
        </template>
        <template v-slot:content>
          <div class="suport_box">
            원하는 그룹명으로 수정해보세요. (<strong>최대 10자</strong>)
          </div>
          <AppTextField v-model="currentGroupName" />

          <Alert :message="message" :message-type="messageType"></Alert>

        </template>
        <template v-slot:actions>
          <TextButtonBlock buttonText="취소" @click="closeModifyGroupName" />
          <TextButtonBlock buttonText="수정" @click="handleUpdateGroupName" isPrimary />
        </template>
      </AppDialog>



    </div>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import PlaylistApi from "@/api/playlist/PlaylistApi";
import AppTextField from '@/components/app/AppTextfield';
import AppDialog from '@/components/app/AppDialog.vue';
import AssetApi from "@/api/asset/AssetApi";
import Alert from '@/components/app/AppAlert.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';

export default {
  components: {
    draggable,
    AppTextField,
    AppDialog,
    Alert,
    TextButtonBlock,
  },
  props: {
    viewType: {
      type: String,
      required: true
    },
  },
  computed: {
    headerTitle() {
      return this.viewType === 'playlist' ? 'Playlist Group List' : 'Asset Group List';
    },
  },
  data() {
    return {
      list: [],
      selectedGroupId: null,
      showGroupDialog: false,
      groupName: null,
      message: '',
      messageType: '',
      currentElementId: null,
      currentGroupName: null,
      showGroupEditDialog: false,
      originalGroupName: null,
      showMenu: false,
      menuOpen: null,
    }
  },
  methods: {
    async handleDrag(event) {
      //console.log('event', event);
      let oldOrder = event.moved.oldIndex + 1;
      let newOrder = event.moved.newIndex + 1;
      const data = {
        order: oldOrder,
        newOrder: newOrder
      };
      try {
        const response = await PlaylistApi.groupDrag(data);
        //console.log('response', response);
      } catch (error) {
        console.error("error", error);
      }
    },
    async handleAdd() {

      if (!this.groupName) {
        this.message = '그룹명을 입력해주세요.';
        this.messageType = 'warning';
        return;
      }

      try {
        if (this.viewType === 'playlist') {
          const response = await PlaylistApi.addPlaylistGroup({ group_name: this.groupName });
          if (response.status === '1') {
            this.fetchGroupList();
            this.showGroupDialog = false;
            this.groupName = '';
          } else if (response.status === '2') {
            this.message = '그룹명 중복입니다.';
            this.messageType = 'error';
          } else if (response.status === '3') {
            this.message = '그룹명 최대 10글자 입니다.';
            this.messageType = 'error';
          }
        } else if (this.viewType === 'asset') {
          const response = await AssetApi.addGroupApi(this.groupName);
          //console.log(response)
          const status = response.status;
          switch (status) {
            case 1:
              this.fetchGroupList();
              this.showGroupDialog = false;
              this.groupName = '';
              break;
            case 2:
              this.message = response.message;
              this.messageType = 'error';
              break;
            case 3:
              this.message = response.message;
              this.messageType = 'error';
              break;
          }
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    async openModifyGroupName(element) {
      this.currentGroupName = element.group_name;
      this.originalGroupName = element.group_name;
      this.currentElementId = element.id;
      this.showGroupEditDialog = true;
    },
    async closeModifyGroupName() {
      this.showGroupEditDialog = false;
      this.message = '';
      this.messageType = '';
    },
    async handleUpdateGroupName() {
      const data = {
        groupName: this.currentGroupName,
        groupId: this.currentElementId
      };

      if (!this.currentGroupName) {
        this.message = '그룹명을 입력해주세요.';
        this.messageType = 'warning';
        return;
      }

      if (this.originalGroupName === this.currentGroupName) {
        this.message = '기존 그룹명과 동일합니다';
        this.messageType = 'warning';
        return;
      }


      try {
        if (this.viewType === 'playlist') {
          //console.log('data', data);
          const response = await PlaylistApi.modifyGroupName(data);
          //console.log('res', response);
          if (response.status === '1') {
            this.fetchGroupList();
            this.showGroupEditDialog = false;
            this.groupName = '';
            this.$store.dispatch('group/updateSelectedGroupId', 'all');
            this.$store.dispatch('group/reportModifyStatus', true);
          } else if (response.status === '4') {
            this.message = '그룹명 중복입니다.';
            this.messageType = 'error';
          } else if (response.status === '3') {
            this.message = '그룹명 최대 10글자 입니다.';
            this.messageType = 'error';
          }
        } else if (this.viewType === 'asset') {
            const params = {
                id: this.currentElementId,
                newName: this.currentGroupName
            };
            const res = await AssetApi.updateGroupApi(params)
            if(res.status === 1){
              this.fetchGroupList();
              this.showGroupEditDialog = false;
              this.groupName = '';
              this.$store.dispatch('group/updateSelectedGroupId', 'all');
              this.$store.dispatch('group/reportModifyStatus', true);
            }
            else if(res.status === 2){
                this.message = res.message;
                this.messageType = 'error';
            }
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    async remove(id) {
      try {
        if (this.viewType === 'playlist') {
          const response = await PlaylistApi.deletePlaylistGroup(id);
          if (response.status === '1') {

            this.$store.dispatch('group/updateSelectedGroupId', 'all');
            this.$store.dispatch('group/reportDeleteStatus', true);
            this.fetchGroupList();
          } else {

          }
        } else if (this.viewType === 'asset') {
          const response = await AssetApi.deleteGroupApi(id);
          if (response.status === 1) {
            this.fetchGroupList();
          } else {

          }
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    async modify(id) {
      //console.log('ids', id);
      try {
        if (this.viewType === 'playlist') {


        } else if (this.viewType === 'asset') {

        }
      } catch (error) {
        console.error("error", error);
      }
    },
    selectAllGroups() {
      this.$store.dispatch('group/updateSelectedGroupId', 'all');
    },
    selectGroup(selectedGroup) {
      //console.log('selectGroup', selectedGroup);
      this.$store.dispatch('group/updateSelectedGroupId', selectedGroup.id);
      this.$store.dispatch('group/updateSelectedGroupName', selectedGroup.group_name);
    },
    async fetchGroupList() {
      try {
        let data = [];
        if (this.viewType === 'playlist') {
          const response = await PlaylistApi.groupListApi();
          data = response;
        } else if (this.viewType === 'asset') {
          const response = await AssetApi.groupApi();
          data = response;
        }
        //console.log('data', data);
        this.$store.commit('asset/setGroupList', data);
        this.list = data;
      } catch (error) {
        console.error("error", error);
        this.list = [];
      }
    },
    elementKey(element) {
      return this.viewType === 'playlist' ? element.order : element.id;
    },
    optionmenu(element) {
      if (this.menuOpen === element.id) {
        this.menuOpen = null;  // 이미 열려 있으면 메뉴를 닫음
      } else {
        this.menuOpen = element.id;  // 클릭된 아이템의 메뉴를 엶
      }
    },
  },
  mounted() {
    //this.selectAllGroups();
  },
  watch: {
    viewType: {
      handler: 'fetchGroupList',
      immediate: true,
    },
    'selectedGroupId'(newVal) {
      if (newVal === 'all') {
        this.selectAllGroups();
        //console.log("all");
      }
    },
    showGroupDialog(newVal) {
      if (!newVal) {
        this.message = '';
        this.messageType = '';
        this.groupName = '';
      }
    }
  },
}
</script>

<style>
.drag-Area {
  padding: 10px;
  margin-bottom: 20px;

}

.drag-list {
  display: flex;
  flex-direction: column;
}

.drag-item {
  padding: 8px;
  margin-bottom: 4px;
  background-color: white;
}

.suport_box {
  padding: 10px;
  background: #f8f8f8;
  margin-bottom: 10px;
}

.suport_box strong {
  color: #006CEA;
}
</style>
